module.exports = __webpack_public_path__ + "media/assets/images/flags/za-3532b2ac6f245516dc3140fca4f4765d.svg";